import './presentation/styles/main.scss';
import './presentation/scripts/vendor/material-components-web.min.js';
import user from './presentation/scripts/user.js';
import signOut from './presentation/scripts/sign-out.js';
import addCampaign from './presentation/scripts/add-campaign.js';
import campaignDetailsPg from './presentation/scripts/campaign-details-pg.js';
import form from './presentation/scripts/form.js';
import editCampaign from './presentation/scripts/edit-campaign.js';
import loadFormData from './presentation/scripts/load-form-data.js';

window.addEventListener('DOMContentLoaded', () => {
    loadFormData.init();
    form.init();
    user.init();
    signOut.init();
    campaignDetailsPg.init();
    editCampaign.init();
    addCampaign.init();
});